module.exports = __webpack_public_path__ + "img/UI_common_framelabelDX_02_3422af948.png";